import { accSub } from "@/utils/math";
export const user_table_column = [
  { key: "appid", name: "序号" },
  { key: "appName", name: "产品名称" },
  { key: "afid", name: "AFID" },
  { key: "afDevKey", name: "AF_Dev key" },
  { key: "dbtId", name: "DBTID" },
  { key: "osType", name: "平台类型 " },
  { key: "latestStatus", name: "产品最新状态" },
  { key: "popuStatus", name: "推广状态", translation: true },
  { key: "mark", name: "备注" },
  { key: "deliveryName", name: "投放主体" },
  { key: "principalUser", name: "负责人" },
  { key: "productGroupName", name: "项目组" },
  { key: "groupName", name: "分组" },
  { key: "afAccountName", name: "af账号ID" },
  { key: "creator", name: "创建人" },
  { key: "modifier", name: "最后修改人" },
  // { key: "operation", name: "操作" },
];
function sortColumn(a, b, key) {
  if (!a[key] && !b[key]) {
    return -1;
  } else if (!a[key] && b[key]) {
    return -1;
  } else if (a[key] && !b[key]) {
    return 1;
  }
  return accSub(a[key], b[key]) > 0 ? 1 : -1;
  // if (a[key] < b[key]) {
  //   return 1;
  // } else if (a[key] > b[key]) {
  //   return -1;
  // } else {
  //   return 1;
  // }
}
export const summary_date_table_column = [
  {
    id: 0,
    key: "date",
    name: "日期",
    sort: true,
    point: 0,
    width: 150,
    fixed: true,
    show: true,
  },
  // { key: 'geo', name: "国家或地区", sort: false, point: 0, width: 150, fixed: true },
  // { key: 'mediaSource', name: "资源", sort: true, point: 0, width: 150, fixed: true },
  {
    id: 1,
    key: "totalIncre",
    name: "总新增",
    sort: true,
    point: 0,
    width: 150,
    sortMethod: (a, b) => sortColumn(a, b, "totalIncre"),
    show: true,
  },
  {
    id: 2,
    key: "popuIncre",
    name: "推广新增",
    sort: true,
    point: 0,
    width: 150,
    sortMethod: (a, b) => sortColumn(a, b, "popuIncre"),
    show: true,
  },
  {
    id: 3,
    key: "orgIncre",
    name: "自然新增",
    sort: true,
    point: 0,
    width: 150,
    sortMethod: (a, b) => sortColumn(a, b, "orgIncre"),
    show: true,
  },
  {
    id: 4,
    key: "orgPercent",
    name: "自然量占比",
    sort: true,
    percent: "%",
    point: 2,
    width: 150,
    sortMethod: (a, b) => sortColumn(a, b, "orgPercent"),
    show: true,
    tip: "自然新增/总新增",
  },
  {
    id: 5,
    key: "activeUser",
    name: "活跃用户",
    sort: true,
    point: 0,
    width: 150,
    sortMethod: (a, b) => sortColumn(a, b, "activeUser"),
    show: true,
    copy: true,
  },
  {
    id: 6,
    key: "activePecent",
    name: "活跃增比",
    sort: true,
    point: 2,
    width: 150,
    sortMethod: (a, b) => sortColumn(a, b, "activePecent"),
    show: true,
    tip: "活跃用户/总新增",
  },
  {
    id: 7,
    key: "cresCost",
    name: "新增单价",
    unit: "$",
    sort: true,
    point: 3,
    width: 150,
    sortMethod: (a, b) => sortColumn(a, b, "cresCost"),
    show: true,
    tip: "支出总计/总新增",
  },
  // {
  //   id: 71,
  //   key: "cresCostDiffer",
  //   name: "同期新增单价增幅",
  //   percent: "%",
  //   sort: true,
  //   point: 2,
  //   width: 170,
  //   sortMethod: (a, b) => sortColumn(a, b, "cresCostDiffer"),
  //   show: true,
  // },
  {
    id: 8,
    key: "popCost",
    name: "推广单价",
    unit: "$",
    sort: true,
    point: 3,
    width: 150,
    sortMethod: (a, b) => sortColumn(a, b, "popCost"),
    show: true,
    tip: "支出总计/推广新增",
  },
  // {
  //   id: 81,
  //   key: "popCostDiffer",
  //   name: "同期推广单价增幅",
  //   percent: "%",
  //   sort: true,
  //   point: 2,
  //   width: 170,
  //   sortMethod: (a, b) => sortColumn(a, b, "popCostDiffer"),
  //   show: true,
  // },
  {
    id: 9,
    key: "arpu",
    name: "变现活跃ARPU",
    unit: "$",
    sort: true,
    point: 3,
    width: 170,
    sortMethod: (a, b) => sortColumn(a, b, "arpu"),
    show: true,
    tip: "变现收入/活跃用户",
  },
  // {
  //   id: 91,
  //   key: "arpuDiffer",
  //   name: "同期ARPU增幅",
  //   percent: "%",
  //   sort: true,
  //   point: 3,
  //   width: 150,
  //   sortMethod: (a, b) => sortColumn(a, b, "arpuDiffer"),
  //   show: true,
  // },
  {
    id: 10,
    key: "estimateValue",
    name: "估算变现价值",
    unit: "$",
    sort: true,
    point: 2,
    width: 150,
    sortMethod: (a, b) => sortColumn(a, b, "estimateValue"),
    show: true,
    tip: "活跃arpu*预估倍数",
  },
  {
    id: 11,
    key: "increRoi",
    name: "新增ROI",
    percent: "%",
    sort: true,
    point: 2,
    width: 150,
    sortMethod: (a, b) => sortColumn(a, b, "increRoi"),
    show: true,
    tip: "估算变现价值/新增单价",
  },
  {
    id: 12,
    key: "popuRoi",
    name: "推广ROI",
    percent: "%",
    sort: true,
    point: 2,
    width: 150,
    sortMethod: (a, b) => sortColumn(a, b, "popuRoi"),
    show: true,
    tip: "估算变现价值/推广单价",
  },
  {
    id: 13,
    key: "incomeTotalUSD",
    name: "变现收入",
    unit: "$",
    sort: true,
    point: 2,
    width: 190,
    sortMethod: (a, b) => sortColumn(a, b, "incomeTotalUSD"),
    show: true,
    copy: true,
  },
  {
    id: 14,
    key: "popTotalUSD",
    name: "推广总计",
    unit: "$",
    sort: true,
    point: 2,
    width: 190,
    sortMethod: (a, b) => sortColumn(a, b, "popTotalUSD"),
    show: true,
    copy: true,
  },
  {
    id: 15,
    key: "toDayROI",
    name: "当前ROI",
    percent: "%",
    sort: true,
    point: 2,
    width: 150,
    sortMethod: (a, b) => sortColumn(a, b, "toDayROI"),
    show: true,
    tip: "（所选时间段内维度下的）收入总计/支出总计",
  },
  {
    id: 16,
    key: "roiTotal",
    name: "历史总ROI",
    percent: "%",
    sort: true,
    point: 2,
    width: 150,
    sortMethod: (a, b) => sortColumn(a, b, "roiTotal"),
    show: true,
    tip: "（累计 ）收入/支出 ，以一个固定值形式呈现",
  },
  {
    id: 17,
    key: "estimateTimes",
    name: "365日LT",
    sort: true,
    point: 2,
    width: 150,
    sortMethod: (a, b) => sortColumn(a, b, "estimateTimes"),
    tip: "基于7日以上留存预估，与所选时间段无关",
  },
  {
    id: 18,
    key: "payIncome",
    name: "内购收入",
    unit: "$",
    sort: true,
    point: 2,
    width: 150,
    sortMethod: (a, b) => sortColumn(a, b, "payIncome"),
    show: true,
    tip: "分成后收入",
  },
  {
    id: 19,
    key: "payPerAdsRate",
    name: "内购收入占比",
    sort: true,
    percent: "%",
    point: 2,
    width: 150,
    sortMethod: (a, b) => sortColumn(a, b, "payPerAdsRate"),
    show: true,
    tip: "内购收入/（变现收入+内购收入）",
  },
  {
    id: 20,
    key: "avgActivePayIncome",
    name: "活跃人均内购",
    unit: "$",
    sort: true,
    point: 2,
    width: 150,
    sortMethod: (a, b) => sortColumn(a, b, "avgActivePayIncome"),
    show: true,
    tip: "内购收入/活跃用户",
  },
  {
    id: 21,
    key: "allTotalIncome",
    name: "收入总计",
    unit: "$",
    sort: true,
    point: 2,
    width: 150,
    sortMethod: (a, b) => sortColumn(a, b, "allTotalIncome"),
    show: true,
    tip: "变现收入+内购收入",
  },
  {
    id: 22,
    key: "currentRoi",
    name: "当前变现ROI",
    percent: "%",
    sort: true,
    point: 2,
    width: 150,
    sortMethod: (a, b) => sortColumn(a, b, "currentRoi"),
    show: true,
    tip: "变现收入/推广总计",
  },
  {
    id: 23,
    key: "predictPayValue",
    name: "估算内购价值",
    unit: "$",
    sort: true,
    point: 2,
    width: 150,
    sortMethod: (a, b) => sortColumn(a, b, "predictPayValue"),
    show: true,
    tip: "活跃人均内购*预估倍数",
  },
  {
    id: 24,
    key: "predictUserValue",
    name: "估算用户价值",
    unit: "$",
    sort: true,
    point: 2,
    width: 150,
    sortMethod: (a, b) => sortColumn(a, b, "predictUserValue"),
    show: true,
    tip: "估算变现价值+估算内购价值",
  },
  {
    id: 25,
    key: "retenRate1",
    name: "1留",
    sort: true,
    point: 2,
    percent: "%",
    width: 150,
    sortMethod: (a, b) => sortColumn(a, b, "retenRate1"),
    show: true,
  },
  {
    id: 26,
    key: "retenRate3",
    name: "3留",
    sort: true,
    point: 2,
    percent: "%",
    width: 150,
    sortMethod: (a, b) => sortColumn(a, b, "retenRate3"),
    show: true,
  },
  {
    id: 27,
    key: "retenRate7",
    name: "7留",
    sort: true,
    point: 2,
    percent: "%",
    width: 150,
    sortMethod: (a, b) => sortColumn(a, b, "retenRate7"),
    show: true,
  },
  {
    id: 28,
    key: "retenRate14",
    name: "14留",
    sort: true,
    point: 2,
    percent: "%",
    width: 150,
    sortMethod: (a, b) => sortColumn(a, b, "retenRate14"),
    show: true,
  },
  {
    id: 29,
    key: "retenRate30",
    name: "30留",
    sort: true,
    point: 2,
    percent: "%",
    width: 150,
    sortMethod: (a, b) => sortColumn(a, b, "retenRate30"),
    show: true,
  },
];
export const summary_country_table_column = [
  {
    id: 0,
    key: "geo",
    name: "国家或地区",
    sort: false,
    point: 0,
    width: 150,
    fixed: true,
  },
  {
    id: 1,
    key: "totalIncre",
    name: "总新增",
    sort: true,
    point: 0,
    width: 150,
    sortMethod: (a, b) => sortColumn(a, b, "totalIncre"),
  },
  {
    id: 2,
    key: "popuIncre",
    name: "推广新增",
    sort: true,
    point: 0,
    width: 150,
    sortMethod: (a, b) => sortColumn(a, b, "popuIncre"),
  },
  {
    id: 3,
    key: "orgIncre",
    name: "自然新增",
    sort: true,
    point: 0,
    width: 150,
    sortMethod: (a, b) => sortColumn(a, b, "orgIncre"),
  },
  {
    id: 4,
    key: "orgPercent",
    name: "自然量占比",
    sort: true,
    percent: "%",
    point: 2,
    width: 150,
    sortMethod: (a, b) => sortColumn(a, b, "orgPercent"),
    tip: "自然新增/总新增",
  },
  {
    id: 5,
    key: "activeUser",
    name: "活跃用户",
    sort: true,
    point: 0,
    width: 150,
    sortMethod: (a, b) => sortColumn(a, b, "activeUser"),
    copy: true,
  },
  {
    id: 6,
    key: "activePecent",
    name: "活跃增比",
    sort: true,
    point: 2,
    width: 150,
    sortMethod: (a, b) => sortColumn(a, b, "activePecent"),
    tip: "活跃用户/总新增",
  },
  {
    id: 7,
    key: "cresCost",
    name: "新增单价",
    unit: "$",
    sort: true,
    point: 3,
    width: 150,
    sortMethod: (a, b) => sortColumn(a, b, "cresCost"),
    tip: "支出总计/总新增",
  },
  {
    id: 71,
    key: "cresCostDiffer",
    name: "同期新增单价增幅",
    percent: "%",
    sort: true,
    point: 2,
    width: 170,
    sortMethod: (a, b) => sortColumn(a, b, "cresCostDiffer"),
    show: true,
  },
  {
    id: 8,
    key: "popCost",
    name: "推广单价",
    unit: "$",
    sort: true,
    point: 3,
    width: 150,
    sortMethod: (a, b) => sortColumn(a, b, "popCost"),
    tip: "支出总计/推广新增",
  },
  {
    id: 81,
    key: "popCostDiffer",
    name: "同期推广单价增幅",
    percent: "%",
    sort: true,
    point: 2,
    width: 170,
    sortMethod: (a, b) => sortColumn(a, b, "popCostDiffer"),
    show: true,
  },
  {
    id: 9,
    key: "arpu",
    name: "变现活跃ARPU",
    unit: "$",
    sort: true,
    point: 3,
    width: 170,
    sortMethod: (a, b) => sortColumn(a, b, "arpu"),
    tip: "变现收入/活跃用户",
  },
  {
    id: 91,
    key: "arpuDiffer",
    name: "同期ARPU增幅",
    percent: "%",
    sort: true,
    point: 3,
    width: 150,
    sortMethod: (a, b) => sortColumn(a, b, "arpuDiffer"),
    show: true,
  },
  {
    id: 10,
    key: "estimateValue",
    name: "估算变现价值",
    unit: "$",
    sort: true,
    point: 2,
    width: 150,
    sortMethod: (a, b) => sortColumn(a, b, "estimateValue"),
    show: true,
    tip: "活跃arpu*预估倍数",
  },
  {
    id: 11,
    key: "increRoi",
    name: "新增ROI",
    percent: "%",
    sort: true,
    point: 2,
    width: 150,
    sortMethod: (a, b) => sortColumn(a, b, "increRoi"),
    show: true,
    tip: "估算变现价值/新增单价",
  },
  {
    id: 12,
    key: "popuRoi",
    name: "推广ROI",
    percent: "%",
    sort: true,
    point: 2,
    width: 150,
    sortMethod: (a, b) => sortColumn(a, b, "popuRoi"),
    show: true,
    tip: "估算变现价值/推广单价",
  },
  {
    id: 13,
    key: "incomeTotalUSD",
    name: "变现收入",
    unit: "$",
    sort: true,
    point: 2,
    width: 190,
    sortMethod: (a, b) => sortColumn(a, b, "incomeTotalUSD"),
    copy: true,
  },
  {
    id: 14,
    key: "popTotalUSD",
    name: "推广总计",
    unit: "$",
    sort: true,
    point: 2,
    width: 190,
    sortMethod: (a, b) => sortColumn(a, b, "popTotalUSD"),
    copy: true,
  },
  {
    id: 15,
    key: "toDayROI",
    name: "当前ROI",
    percent: "%",
    sort: true,
    point: 2,
    width: 150,
    sortMethod: (a, b) => sortColumn(a, b, "toDayROI"),
    tip: "（所选时间段内维度下的）收入总计/支出总计",
  },
  {
    id: 16,
    key: "roiTotal",
    name: "总ROI",
    percent: "%",
    sort: true,
    point: 2,
    width: 150,
    sortMethod: (a, b) => sortColumn(a, b, "roiTotal"),
    tip: "（累计 ）收入/支出 ，以一个固定值形式呈现",
  },
  {
    id: 17,
    key: "estimateTimes",
    name: "365日LT",
    sort: true,
    point: 2,
    width: 150,
    sortMethod: (a, b) => sortColumn(a, b, "estimateTimes"),
    tip: "基于7日以上留存预估，与所选时间段无关",
  },
  {
    id: 18,
    key: "payIncome",
    name: "内购收入",
    unit: "$",
    sort: true,
    point: 2,
    width: 150,
    sortMethod: (a, b) => sortColumn(a, b, "payIncome"),
    show: true,
    tip: "分成后收入",
  },
  {
    id: 19,
    key: "payPerAdsRate",
    name: "内购收入占比",
    sort: true,
    percent: "%",
    point: 2,
    width: 150,
    sortMethod: (a, b) => sortColumn(a, b, "payPerAdsRate"),
    show: true,
    tip: "内购收入/（变现收入+内购收入）",
  },
  {
    id: 20,
    key: "avgActivePayIncome",
    name: "活跃人均内购",
    unit: "$",
    sort: true,
    point: 2,
    width: 150,
    sortMethod: (a, b) => sortColumn(a, b, "avgActivePayIncome"),
    show: true,
    tip: "内购收入/活跃用户",
  },
  {
    id: 21,
    key: "allTotalIncome",
    name: "收入总计",
    unit: "$",
    sort: true,
    point: 2,
    width: 150,
    sortMethod: (a, b) => sortColumn(a, b, "allTotalIncome"),
    show: true,
    tip: "变现收入+内购收入",
  },
  {
    id: 22,
    key: "currentRoi",
    name: "当前变现ROI",
    percent: "%",
    sort: true,
    point: 2,
    width: 150,
    sortMethod: (a, b) => sortColumn(a, b, "currentRoi"),
    show: true,
    tip: "变现收入/推广总计",
  },
  {
    id: 23,
    key: "predictPayValue",
    name: "估算内购价值",
    unit: "$",
    sort: true,
    point: 2,
    width: 150,
    sortMethod: (a, b) => sortColumn(a, b, "predictPayValue"),
    show: true,
    tip: "活跃人均内购*预估倍数",
  },
  {
    id: 24,
    key: "predictUserValue",
    name: "估算用户价值",
    unit: "$",
    sort: true,
    point: 2,
    width: 150,
    sortMethod: (a, b) => sortColumn(a, b, "predictUserValue"),
    show: true,
    tip: "估算变现价值+估算内购价值",
  },
  {
    id: 25,
    key: "retenRate1",
    name: "1留",
    sort: true,
    point: 2,
    percent: "%",
    width: 150,
    sortMethod: (a, b) => sortColumn(a, b, "retenRate1"),
  },
  {
    id: 26,
    key: "retenRate3",
    name: "3留",
    sort: true,
    point: 2,
    percent: "%",
    width: 150,
    sortMethod: (a, b) => sortColumn(a, b, "retenRate3"),
  },
  {
    id: 27,
    key: "retenRate7",
    name: "7留",
    sort: true,
    point: 2,
    percent: "%",
    width: 150,
    sortMethod: (a, b) => sortColumn(a, b, "retenRate7"),
  },
  {
    id: 28,
    key: "retenRate14",
    name: "14留",
    sort: true,
    point: 2,
    percent: "%",
    width: 150,
    sortMethod: (a, b) => sortColumn(a, b, "retenRate14"),
  },
  {
    id: 29,
    key: "retenRate30",
    name: "30留",
    sort: true,
    point: 2,
    percent: "%",
    width: 150,
    sortMethod: (a, b) => sortColumn(a, b, "retenRate30"),
  },
];
export const summary_medio_table_column = [
  {
    id: 0,
    key: "mediaSource",
    name: "资源",
    sort: true,
    point: 0,
    width: 150,
    fixed: true,
  },
  {
    id: 1,
    key: "totalIncre",
    name: "总新增",
    sort: true,
    point: 0,
    width: 150,
    sortMethod: (a, b) => sortColumn(a, b, "totalIncre"),
  },
  {
    id: 2,
    key: "popuIncre",
    name: "推广新增",
    sort: true,
    point: 0,
    width: 150,
    sortMethod: (a, b) => sortColumn(a, b, "popuIncre"),
  },
  {
    id: 3,
    key: "orgIncre",
    name: "自然新增",
    sort: true,
    point: 0,
    width: 150,
    sortMethod: (a, b) => sortColumn(a, b, "orgIncre"),
  },
  {
    id: 4,
    key: "orgPercent",
    name: "自然量占比",
    sort: true,
    percent: "%",
    point: 2,
    width: 150,
    sortMethod: (a, b) => sortColumn(a, b, "orgPercent"),
    tip: "自然新增/总新增",
  },
  {
    id: 5,
    key: "activeUser",
    name: "活跃用户",
    sort: true,
    point: 0,
    width: 150,
    sortMethod: (a, b) => sortColumn(a, b, "activeUser"),
    copy: true,
  },
  {
    id: 6,
    key: "activePecent",
    name: "活跃增比",
    sort: true,
    point: 2,
    width: 150,
    sortMethod: (a, b) => sortColumn(a, b, "activePecent"),
    tip: "活跃用户/总新增",
  },
  {
    id: 7,
    key: "cresCost",
    name: "新增单价",
    unit: "$",
    sort: true,
    point: 3,
    width: 150,
    sortMethod: (a, b) => sortColumn(a, b, "cresCost"),
    tip: "支出总计/总新增",
  },
  {
    id: 71,
    key: "cresCostDiffer",
    name: "同期新增单价增幅",
    percent: "%",
    sort: true,
    point: 2,
    width: 170,
    sortMethod: (a, b) => sortColumn(a, b, "cresCostDiffer"),
    show: true,
  },
  {
    id: 8,
    key: "popCost",
    name: "推广单价",
    unit: "$",
    sort: true,
    point: 3,
    width: 150,
    sortMethod: (a, b) => sortColumn(a, b, "popCost"),
    tip: "支出总计/推广新增",
  },
  {
    id: 81,
    key: "popCostDiffer",
    name: "同期推广单价增幅",
    percent: "%",
    sort: true,
    point: 2,
    width: 170,
    sortMethod: (a, b) => sortColumn(a, b, "popCostDiffer"),
    show: true,
  },
  {
    id: 9,
    key: "arpu",
    name: "变现活跃ARPU",
    unit: "$",
    sort: true,
    point: 3,
    width: 170,
    sortMethod: (a, b) => sortColumn(a, b, "arpu"),
    tip: "变现收入/活跃用户",
  },
  {
    id: 91,
    key: "arpuDiffer",
    name: "同期ARPU增幅",
    percent: "%",
    sort: true,
    point: 3,
    width: 150,
    sortMethod: (a, b) => sortColumn(a, b, "arpuDiffer"),
    show: true,
  },
  {
    id: 10,
    key: "estimateValue",
    name: "估算变现价值",
    unit: "$",
    sort: true,
    point: 2,
    width: 150,
    sortMethod: (a, b) => sortColumn(a, b, "estimateValue"),
    show: true,
    tip: "活跃arpu*预估倍数",
  },
  {
    id: 11,
    key: "increRoi",
    name: "新增ROI",
    percent: "%",
    sort: true,
    point: 2,
    width: 150,
    sortMethod: (a, b) => sortColumn(a, b, "increRoi"),
    show: true,
    tip: "估算变现价值/新增单价",
  },
  {
    id: 12,
    key: "popuRoi",
    name: "推广ROI",
    percent: "%",
    sort: true,
    point: 2,
    width: 150,
    sortMethod: (a, b) => sortColumn(a, b, "popuRoi"),
    show: true,
    tip: "估算变现价值/推广单价",
  },
  {
    id: 13,
    key: "incomeTotalUSD",
    name: "变现收入",
    unit: "$",
    sort: true,
    point: 2,
    width: 190,
    sortMethod: (a, b) => sortColumn(a, b, "incomeTotalUSD"),
    copy: true,
  },
  {
    id: 14,
    key: "popTotalUSD",
    name: "推广总计",
    unit: "$",
    sort: true,
    point: 2,
    width: 190,
    sortMethod: (a, b) => sortColumn(a, b, "popTotalUSD"),
    copy: true,
  },
  {
    id: 15,
    key: "toDayROI",
    name: "当前ROI",
    percent: "%",
    sort: true,
    point: 2,
    width: 150,
    sortMethod: (a, b) => sortColumn(a, b, "toDayROI"),
    tip: "（所选时间段内维度下的）收入总计/支出总计",
  },
  {
    id: 16,
    key: "roiTotal",
    name: "总ROI",
    percent: "%",
    sort: true,
    point: 2,
    width: 150,
    sortMethod: (a, b) => sortColumn(a, b, "roiTotal"),
    tip: "（累计 ）收入/支出 ，以一个固定值形式呈现",
  },
  {
    id: 17,
    key: "estimateTimes",
    name: "365日LT",
    sort: true,
    point: 2,
    width: 150,
    sortMethod: (a, b) => sortColumn(a, b, "estimateTimes"),
    tip: "基于7日以上留存预估，与所选时间段无关",
  },
  {
    id: 18,
    key: "payIncome",
    name: "内购收入",
    unit: "$",
    sort: true,
    point: 2,
    width: 150,
    sortMethod: (a, b) => sortColumn(a, b, "payIncome"),
    show: true,
    tip: "分成后收入",
  },
  {
    id: 19,
    key: "payPerAdsRate",
    name: "内购收入占比",
    sort: true,
    percent: "%",
    point: 2,
    width: 150,
    sortMethod: (a, b) => sortColumn(a, b, "payPerAdsRate"),
    show: true,
    tip: "内购收入/（变现收入+内购收入）",
  },
  {
    id: 20,
    key: "avgActivePayIncome",
    name: "活跃人均内购",
    unit: "$",
    sort: true,
    point: 2,
    width: 150,
    sortMethod: (a, b) => sortColumn(a, b, "avgActivePayIncome"),
    show: true,
    tip: "内购收入/活跃用户",
  },
  {
    id: 21,
    key: "allTotalIncome",
    name: "收入总计",
    unit: "$",
    sort: true,
    point: 2,
    width: 150,
    sortMethod: (a, b) => sortColumn(a, b, "allTotalIncome"),
    show: true,
    tip: "变现收入+内购收入",
  },
  {
    id: 22,
    key: "currentRoi",
    name: "当前变现ROI",
    percent: "%",
    sort: true,
    point: 2,
    width: 150,
    sortMethod: (a, b) => sortColumn(a, b, "currentRoi"),
    show: true,
    tip: "变现收入/推广总计",
  },
  {
    id: 23,
    key: "predictPayValue",
    name: "估算内购价值",
    unit: "$",
    sort: true,
    point: 2,
    width: 150,
    sortMethod: (a, b) => sortColumn(a, b, "predictPayValue"),
    show: true,
    tip: "活跃人均内购*预估倍数",
  },
  {
    id: 24,
    key: "predictUserValue",
    name: "估算用户价值",
    unit: "$",
    sort: true,
    point: 2,
    width: 150,
    sortMethod: (a, b) => sortColumn(a, b, "predictUserValue"),
    show: true,
    tip: "估算变现价值+估算内购价值",
  },
  {
    id: 25,
    key: "retenRate1",
    name: "1留",
    sort: true,
    point: 2,
    percent: "%",
    width: 150,
    sortMethod: (a, b) => sortColumn(a, b, "retenRate1"),
  },
  {
    id: 26,
    key: "retenRate3",
    name: "3留",
    sort: true,
    point: 2,
    percent: "%",
    width: 150,
    sortMethod: (a, b) => sortColumn(a, b, "retenRate3"),
  },
  {
    id: 27,
    key: "retenRate7",
    name: "7留",
    sort: true,
    point: 2,
    percent: "%",
    width: 150,
    sortMethod: (a, b) => sortColumn(a, b, "retenRate7"),
  },
  {
    id: 28,
    key: "retenRate14",
    name: "14留",
    sort: true,
    point: 2,
    percent: "%",
    width: 150,
    sortMethod: (a, b) => sortColumn(a, b, "retenRate14"),
  },
  {
    id: 29,
    key: "retenRate30",
    name: "30留",
    sort: true,
    point: 2,
    percent: "%",
    width: 150,
    sortMethod: (a, b) => sortColumn(a, b, "retenRate30"),
  },
];
export const summary_camp_table_column = [
  {
    id: 999,
    key: "mediaSource",
    name: "资源",
    sort: false,
    point: 0,
    width: 150,
    fixed: true,
  },
  {
    id: 0,
    key: "campaign",
    name: "campaign",
    sort: false,
    point: 0,
    width: 150,
    fixed: true,
  },
  {
    id: 1,
    key: "totalIncre",
    name: "总新增",
    sort: true,
    point: 0,
    width: 150,
    sortMethod: (a, b) => sortColumn(a, b, "totalIncre"),
  },
  {
    id: 2,
    key: "popuIncre",
    name: "推广新增",
    sort: true,
    point: 0,
    width: 150,
    sortMethod: (a, b) => sortColumn(a, b, "popuIncre"),
  },
  {
    id: 3,
    key: "orgIncre",
    name: "自然新增",
    sort: true,
    point: 0,
    width: 150,
    sortMethod: (a, b) => sortColumn(a, b, "orgIncre"),
  },
  {
    id: 4,
    key: "orgPercent",
    name: "自然量占比",
    sort: true,
    percent: "%",
    point: 2,
    width: 150,
    sortMethod: (a, b) => sortColumn(a, b, "orgPercent"),
    tip: "自然新增/总新增",
  },
  {
    id: 5,
    key: "activeUser",
    name: "活跃用户",
    sort: true,
    point: 0,
    width: 150,
    sortMethod: (a, b) => sortColumn(a, b, "activeUser"),
    copy: true,
  },
  {
    id: 6,
    key: "activePecent",
    name: "活跃增比",
    sort: true,
    point: 2,
    width: 150,
    sortMethod: (a, b) => sortColumn(a, b, "activePecent"),
    tip: "活跃用户/总新增",
  },
  {
    id: 7,
    key: "cresCost",
    name: "新增单价",
    unit: "$",
    sort: true,
    point: 3,
    width: 150,
    sortMethod: (a, b) => sortColumn(a, b, "cresCost"),
    tip: "支出总计/总新增",
  },
  {
    id: 71,
    key: "cresCostDiffer",
    name: "同期新增单价增幅",
    percent: "%",
    sort: true,
    point: 2,
    width: 170,
    sortMethod: (a, b) => sortColumn(a, b, "cresCostDiffer"),
    show: true,
  },
  {
    id: 8,
    key: "popCost",
    name: "推广单价",
    unit: "$",
    sort: true,
    point: 3,
    width: 150,
    sortMethod: (a, b) => sortColumn(a, b, "popCost"),
    tip: "支出总计/推广新增",
  },
  {
    id: 81,
    key: "popCostDiffer",
    name: "同期推广单价增幅",
    percent: "%",
    sort: true,
    point: 2,
    width: 170,
    sortMethod: (a, b) => sortColumn(a, b, "popCostDiffer"),
    show: true,
  },
  {
    id: 9,
    key: "arpu",
    name: "变现活跃ARPU",
    unit: "$",
    sort: true,
    point: 3,
    width: 170,
    sortMethod: (a, b) => sortColumn(a, b, "arpu"),
    tip: "变现收入/活跃用户",
  },
  {
    id: 91,
    key: "arpuDiffer",
    name: "同期ARPU增幅",
    percent: "%",
    sort: true,
    point: 3,
    width: 150,
    sortMethod: (a, b) => sortColumn(a, b, "arpuDiffer"),
    show: true,
  },
  {
    id: 10,
    key: "estimateValue",
    name: "估算变现价值",
    unit: "$",
    sort: true,
    point: 2,
    width: 150,
    sortMethod: (a, b) => sortColumn(a, b, "estimateValue"),
    show: true,
    tip: "活跃arpu*预估倍数",
  },
  {
    id: 11,
    key: "increRoi",
    name: "新增ROI",
    percent: "%",
    sort: true,
    point: 2,
    width: 150,
    sortMethod: (a, b) => sortColumn(a, b, "increRoi"),
    show: true,
    tip: "估算变现价值/新增单价",
  },
  {
    id: 12,
    key: "popuRoi",
    name: "推广ROI",
    percent: "%",
    sort: true,
    point: 2,
    width: 150,
    sortMethod: (a, b) => sortColumn(a, b, "popuRoi"),
    show: true,
    tip: "估算变现价值/推广单价",
  },
  {
    id: 13,
    key: "incomeTotalUSD",
    name: "变现收入",
    unit: "$",
    sort: true,
    point: 2,
    width: 190,
    sortMethod: (a, b) => sortColumn(a, b, "incomeTotalUSD"),
    copy: true,
  },
  {
    id: 14,
    key: "popTotalUSD",
    name: "推广总计",
    unit: "$",
    sort: true,
    point: 2,
    width: 190,
    sortMethod: (a, b) => sortColumn(a, b, "popTotalUSD"),
    copy: true,
  },
  {
    id: 15,
    key: "toDayROI",
    name: "当前ROI",
    percent: "%",
    sort: true,
    point: 2,
    width: 150,
    sortMethod: (a, b) => sortColumn(a, b, "toDayROI"),
    tip: "（所选时间段内维度下的）收入总计/支出总计",
  },
  {
    id: 16,
    key: "roiTotal",
    name: "总ROI",
    percent: "%",
    sort: true,
    point: 2,
    width: 150,
    sortMethod: (a, b) => sortColumn(a, b, "roiTotal"),
    tip: "（累计 ）收入/支出 ，以一个固定值形式呈现",
  },
  {
    id: 17,
    key: "estimateTimes",
    name: "365日LT",
    sort: true,
    point: 2,
    width: 150,
    sortMethod: (a, b) => sortColumn(a, b, "estimateTimes"),
    tip: "基于7日以上留存预估，与所选时间段无关",
  },
  {
    id: 18,
    key: "payIncome",
    name: "内购收入",
    unit: "$",
    sort: true,
    point: 2,
    width: 150,
    sortMethod: (a, b) => sortColumn(a, b, "payIncome"),
    show: true,
    tip: "分成后收入",
  },
  {
    id: 19,
    key: "payPerAdsRate",
    name: "内购收入占比",
    sort: true,
    percent: "%",
    point: 2,
    width: 150,
    sortMethod: (a, b) => sortColumn(a, b, "payPerAdsRate"),
    show: true,
    tip: "内购收入/（变现收入+内购收入）",
  },
  {
    id: 20,
    key: "avgActivePayIncome",
    name: "活跃人均内购",
    unit: "$",
    sort: true,
    point: 2,
    width: 150,
    sortMethod: (a, b) => sortColumn(a, b, "avgActivePayIncome"),
    show: true,
    tip: "内购收入/活跃用户",
  },
  {
    id: 21,
    key: "allTotalIncome",
    name: "收入总计",
    unit: "$",
    sort: true,
    point: 2,
    width: 150,
    sortMethod: (a, b) => sortColumn(a, b, "allTotalIncome"),
    show: true,
    tip: "变现收入+内购收入",
  },
  {
    id: 22,
    key: "currentRoi",
    name: "当前变现ROI",
    percent: "%",
    sort: true,
    point: 2,
    width: 150,
    sortMethod: (a, b) => sortColumn(a, b, "currentRoi"),
    show: true,
    tip: "变现收入/推广总计",
  },
  {
    id: 23,
    key: "predictPayValue",
    name: "估算内购价值",
    unit: "$",
    sort: true,
    point: 2,
    width: 150,
    sortMethod: (a, b) => sortColumn(a, b, "predictPayValue"),
    show: true,
    tip: "活跃人均内购*预估倍数",
  },
  {
    id: 24,
    key: "predictUserValue",
    name: "估算用户价值",
    unit: "$",
    sort: true,
    point: 2,
    width: 150,
    sortMethod: (a, b) => sortColumn(a, b, "predictUserValue"),
    show: true,
    tip: "估算变现价值+估算内购价值",
  },
  {
    id: 25,
    key: "retenRate1",
    name: "1留",
    sort: true,
    point: 2,
    percent: "%",
    width: 150,
    sortMethod: (a, b) => sortColumn(a, b, "retenRate1"),
  },
  {
    id: 26,
    key: "retenRate3",
    name: "3留",
    sort: true,
    point: 2,
    percent: "%",
    width: 150,
    sortMethod: (a, b) => sortColumn(a, b, "retenRate3"),
  },
  {
    id: 27,
    key: "retenRate7",
    name: "7留",
    sort: true,
    point: 2,
    percent: "%",
    width: 150,
    sortMethod: (a, b) => sortColumn(a, b, "retenRate7"),
  },
  {
    id: 28,
    key: "retenRate14",
    name: "14留",
    sort: true,
    point: 2,
    percent: "%",
    width: 150,
    sortMethod: (a, b) => sortColumn(a, b, "retenRate14"),
  },
  {
    id: 29,
    key: "retenRate30",
    name: "30留",
    sort: true,
    point: 2,
    percent: "%",
    width: 150,
    sortMethod: (a, b) => sortColumn(a, b, "retenRate30"),
  },
];
export const product_table_column_shu = [
  {
    key: "installDay",
    name: "日期",
    sort: true,
    width: 150,
    fixed: true,
    sortMethod: function (a, b) {
      if (!a.installDay && !b.installDay) {
        return -1;
      } else if (!a.installDay && b.installDay) {
        return -1;
      } else if (a.installDay && !b.installDay) {
        return 1;
      }
    },
  },
  {
    key: "totalIncre",
    name: "总新增",
    sort: true,
    sortMethod: (a, b) => sortColumn(a, b, "totalIncre"),
  },
  {
    key: "popuIncre",
    name: "推广新增",
    sort: true,
    sortMethod: (a, b) => sortColumn(a, b, "popuIncre"),
  },
  {
    key: "orgIncre",
    name: "自然新增",
    sort: true,
    sortMethod: (a, b) => sortColumn(a, b, "orgIncre"),
  },
  {
    key: "dau",
    name: "活跃用户",
    sort: true,
    sortMethod: (a, b) => sortColumn(a, b, "dau"),
  },
  {
    key: "retention1",
    name: "1留",
    sort: true,
    sortMethod: (a, b) => sortColumn(a, b, "retention1"),
  },
  {
    key: "retention3",
    name: "3留",
    sort: true,
    sortMethod: (a, b) => sortColumn(a, b, "retention3"),
  },
  {
    key: "retention7",
    name: "7留",
    sort: true,
    sortMethod: (a, b) => sortColumn(a, b, "retention7"),
  },
  {
    key: "retention14",
    name: "14留",
    sort: true,
    sortMethod: (a, b) => sortColumn(a, b, "retention14"),
  },
  {
    key: "retention30",
    name: "30留",
    sort: true,
    sortMethod: (a, b) => sortColumn(a, b, "retention30"),
  },
];
export const product_table_column_shu_geo = [
  { key: "geo", name: "国家或地区", sort: false, fixed: true, width: 150 },
  {
    key: "totalIncre",
    name: "总新增",
    sort: true,
    sortMethod: (a, b) => sortColumn(a, b, "totalIncre"),
  },
  {
    key: "popuIncre",
    name: "推广新增",
    sort: true,
    sortMethod: (a, b) => sortColumn(a, b, "totalIncre"),
  },
  {
    key: "orgIncre",
    name: "自然新增",
    sort: true,
    sortMethod: (a, b) => sortColumn(a, b, "totalIncre"),
  },
  {
    key: "dau",
    name: "活跃用户",
    sort: true,
    sortMethod: (a, b) => sortColumn(a, b, "totalIncre"),
  },
  {
    key: "retention1",
    name: "1留",
    sort: true,
    sortMethod: (a, b) => sortColumn(a, b, "retention1"),
  },
  {
    key: "retention3",
    name: "3留",
    sort: true,
    sortMethod: (a, b) => sortColumn(a, b, "retention3"),
  },
  {
    key: "retention7",
    name: "7留",
    sort: true,
    sortMethod: (a, b) => sortColumn(a, b, "retention7"),
  },
  {
    key: "retention14",
    name: "14留",
    sort: true,
    sortMethod: (a, b) => sortColumn(a, b, "retention14"),
  },
  {
    key: "retention30",
    name: "30留",
    sort: true,
    sortMethod: (a, b) => sortColumn(a, b, "retention30"),
  },
];
export const product_table_column_lv = [
  { key: "installDay", name: "日期", sort: true, fixed: true, width: 150 },
  {
    key: "totalIncre",
    name: "总新增",
    sort: true,
    sortMethod: (a, b) => sortColumn(a, b, "totalIncre"),
  },
  {
    key: "popuIncre",
    name: "推广新增",
    sort: true,
    sortMethod: (a, b) => sortColumn(a, b, "popuIncre"),
  },
  {
    key: "orgIncre",
    name: "自然新增",
    sort: true,
    sortMethod: (a, b) => sortColumn(a, b, "orgIncre"),
  },
  {
    key: "dau",
    name: "活跃用户",
    sort: true,
    sortMethod: (a, b) => sortColumn(a, b, "dau"),
  },
  {
    key: "size1",
    name: "1留",
    percent: "%",
    sort: true,
    sortMethod: (a, b) => sortColumn(a, b, "size1"),
  },
  {
    key: "size3",
    name: "3留",
    percent: "%",
    sort: true,
    sortMethod: (a, b) => sortColumn(a, b, "size3"),
  },
  {
    key: "size7",
    name: "7留",
    percent: "%",
    sort: true,
    sortMethod: (a, b) => sortColumn(a, b, "size7"),
  },
  {
    key: "size14",
    name: "14留",
    percent: "%",
    sort: true,
    sortMethod: (a, b) => sortColumn(a, b, "size14"),
  },
  {
    key: "size30",
    name: "30留",
    percent: "%",
    sort: true,
    sortMethod: (a, b) => sortColumn(a, b, "size30"),
  },
];
export const product_table_column_lv_geo = [
  { key: "geo", name: "国家或地区", sort: true, fixed: true, width: 150 },
  {
    key: "totalIncre",
    name: "总新增",
    sort: true,
    sortMethod: (a, b) => sortColumn(a, b, "totalIncre"),
  },
  {
    key: "popuIncre",
    name: "推广新增",
    sort: true,
    sortMethod: (a, b) => sortColumn(a, b, "popuIncre"),
  },
  {
    key: "orgIncre",
    name: "自然新增",
    sort: true,
    sortMethod: (a, b) => sortColumn(a, b, "orgIncre"),
  },
  {
    key: "dau",
    name: "活跃用户",
    sort: true,
    sortMethod: (a, b) => sortColumn(a, b, "dau"),
  },
  {
    key: "size1",
    name: "1留",
    percent: "%",
    sort: true,
    sortMethod: (a, b) => sortColumn(a, b, "size1"),
  },
  {
    key: "size3",
    name: "3留",
    percent: "%",
    sort: true,
    sortMethod: (a, b) => sortColumn(a, b, "size3"),
  },
  {
    key: "size7",
    name: "7留",
    percent: "%",
    sort: true,
    sortMethod: (a, b) => sortColumn(a, b, "size7"),
  },
  {
    key: "size14",
    name: "14留",
    percent: "%",
    sort: true,
    sortMethod: (a, b) => sortColumn(a, b, "size14"),
  },
  {
    key: "size30",
    name: "30留",
    percent: "%",
    sort: true,
    sortMethod: (a, b) => sortColumn(a, b, "size30"),
  },
];
export const allreport_table_column = [
  { key: "ord", name: "序号", fixed: true, point: 0, width: 150 },
  { key: "appName", name: "产品名称", point: 0, width: 150, fixed: true },
  { key: "osType", name: "平台", point: 0, fixed: true },
  // { key: 'osType', name: '平台', filters: [{ text: 'android', value: 'android' }, { text: 'google', value: 'google' }, { text: 'ios', value: 'ios' }] },
  { key: "popuStatus", name: "推广状态", point: 0, width: 120 },
  { key: "latestStatus", name: "产品最新状态", width: 150, point: 0 },
  {
    key: "totalIncre",
    name: "总新增",
    width: 120,
    sort: true,
    point: 0,
    sortMethod: function (a, b) {
      if (!a.totalIncre && !b.totalIncre) {
        return -1;
      } else if (!a.totalIncre && b.totalIncre) {
        return -1;
      } else if (a.totalIncre && !b.totalIncre) {
        return 1;
      }

      return a.totalIncre - b.totalIncre >= 0 ? 1 : -1;
    },
    type: "number",
  },
  {
    key: "popuIncre",
    name: "推广新增",
    width: 120,
    point: 0,
    sort: true,
    sortMethod: function (a, b) {
      if (!a.popuIncre && !b.popuIncre) {
        return -1;
      } else if (!a.popuIncre && b.popuIncre) {
        return -1;
      } else if (a.popuIncre && !b.popuIncre) {
        return 1;
      }
      return a.popuIncre - b.popuIncre >= 0 ? 1 : -1;
    },
  },
  {
    key: "orgIncre",
    name: "自然新增",
    point: 0,
    width: 120,
    sort: true,
    sortMethod: function (a, b) {
      if (!a.orgIncre && !b.orgIncre) {
        return -1;
      } else if (!a.orgIncre && b.orgIncre) {
        return -1;
      } else if (a.orgIncre && !b.orgIncre) {
        return 1;
      }
      return a.orgIncre - b.orgIncre >= 0 ? 1 : -1;
    },
  },
  {
    key: "activeUser",
    name: "活跃用户",
    point: 0,
    width: 120,
    sort: true,
    sortMethod: function (a, b) {
      if (!a.activeUser && !b.activeUser) {
        return -1;
      } else if (!a.activeUser && b.activeUser) {
        return -1;
      } else if (a.activeUser && !b.activeUser) {
        return 1;
      }
      return a.activeUser - b.activeUser >= 0 ? 1 : -1;
    },
  },
  {
    key: "payIncome",
    name: "内购收入",
    width: 120,
    unit: "$",
    point: 2,
    sort: true,
    sortMethod: function (a, b) {
      if (!a.payIncome && !b.payIncome) {
        return -1;
      } else if (!a.payIncome && b.payIncome) {
        return -1;
      } else if (a.payIncome && !b.payIncome) {
        return 1;
      }
      return a.payIncome - b.payIncome >= 0 ? 1 : -1;
    },
  },
  {
    key: "incomeTotalUSD",
    name: "变现收入",
    unit: "$",
    width: 120,
    point: 2,
    sort: true,
    sortMethod: function (a, b) {
      if (!a.incomeTotalUSD && !b.incomeTotalUSD) {
        return -1;
      } else if (!a.incomeTotalUSD && b.incomeTotalUSD) {
        return -1;
      } else if (a.incomeTotalUSD && !b.incomeTotalUSD) {
        return 1;
      }
      return a.incomeTotalUSD - b.incomeTotalUSD >= 0 ? 1 : -1;
    },
  },
  {
    key: "cresCost",
    name: "新增单价",
    unit: "$",
    point: 2,
    width: 120,
    sort: true,
    sortMethod: function (a, b) {
      if (!a.cresCost && !b.cresCost) {
        return -1;
      } else if (!a.cresCost && b.cresCost) {
        return -1;
      } else if (a.cresCost && !b.cresCost) {
        return 1;
      }
      return a.cresCost - b.cresCost >= 0 ? 1 : -1;
    },
    tip: "支出总计/总新增",
  },
  {
    key: "popCost",
    name: "推广单价",
    unit: "$",
    point: 0,
    width: 120,
    sort: true,
    sortMethod: function (a, b) {
      if (!a.popCost && !b.popCost) {
        return -1;
      } else if (!a.popCost && b.popCost) {
        return -1;
      } else if (a.popCost && !b.popCost) {
        return 1;
      }
      return a.popCost - b.popCost >= 0 ? 1 : -1;
    },
    tip: "支出总计/推广新增",
  },
  {
    key: "arpu",
    name: "变现活跃ARPU",
    unit: "$",
    point: 3,
    width: 170,
    sort: true,
    sortMethod: function (a, b) {
      if (!a.arpu && !b.arpu) {
        return -1;
      } else if (!a.arpu && b.arpu) {
        return -1;
      } else if (a.arpu && !b.arpu) {
        return 1;
      }
      return a.arpu - b.arpu >= 0 ? 1 : -1;
    },
    tip: "变现收入/活跃用户",
  },
  {
    key: "allTotalIncome",
    name: "收入总计",
    unit: "$",
    point: 2,
    width: 120,
    sort: true,
    sortMethod: function (a, b) {
      if (!a.allTotalIncome && !b.allTotalIncome) {
        return -1;
      } else if (!a.allTotalIncome && b.allTotalIncome) {
        return -1;
      } else if (a.allTotalIncome && !b.allTotalIncome) {
        return 1;
      }
      return a.allTotalIncome - b.allTotalIncome >= 0 ? 1 : -1;
    },
  },
  {
    key: "popTotalUSD",
    name: "推广总计",
    unit: "$",
    point: 2,
    width: 120,
    sort: true,
    sortMethod: function (a, b) {
      if (!a.popTotalUSD && !b.popTotalUSD) {
        return -1;
      } else if (!a.popTotalUSD && b.popTotalUSD) {
        return -1;
      } else if (a.popTotalUSD && !b.popTotalUSD) {
        return 1;
      }
      return a.popTotalUSD - b.popTotalUSD >= 0 ? 1 : -1;
    },
  },
  {
    key: "roiTotal",
    name: "总ROI",
    point: 2,
    width: 120,
    percent: "%",
    sort: true,
    sortMethod: function (a, b) {
      if (!a.roiTotal && !b.roiTotal) {
        return -1;
      } else if (!a.roiTotal && b.roiTotal) {
        return -1;
      } else if (a.roiTotal && !b.roiTotal) {
        return 1;
      }
      return a.roiTotal - b.roiTotal >= 0 ? 1 : -1;
    },
    tip: "（累计 ）收入/支出 ，以一个固定值形式呈现",
  },
];
export const allreport_table_column_bak = [
  { key: "ord", name: "序号", fixed: true, point: 0, width: 150 },
  { key: "appName", name: "产品名称", point: 0, width: 150, fixed: true },
  { key: "osType", name: "平台", point: 0, fixed: true },
  // { key: 'osType', name: '平台', filters: [{ text: 'android', value: 'android' }, { text: 'google', value: 'google' }, { text: 'ios', value: 'ios' }] },
  // { key: "popuStatus", name: "推广状态", point: 0, width: 120 },
  { key: "lineCharts", name: "30日新增曲线", width: 150, point: 0 },
  {
    key: "totalIncre",
    name: "总新增",
    width: 120,
    sort: true,
    point: 0,
    sortMethod: function (a, b) {
      if (!a.totalIncre && !b.totalIncre) {
        return -1;
      } else if (!a.totalIncre && b.totalIncre) {
        return -1;
      } else if (a.totalIncre && !b.totalIncre) {
        return 1;
      }

      return a.totalIncre - b.totalIncre >= 0 ? 1 : -1;
    },
    type: "number",
  },
  {
    key: "allTotalIncome",
    name: "收入总计",
    unit: "$",
    point: 2,
    width: 120,
    sort: true,
    sortMethod: function (a, b) {
      if (!a.allTotalIncome && !b.allTotalIncome) {
        return -1;
      } else if (!a.allTotalIncome && b.allTotalIncome) {
        return -1;
      } else if (a.allTotalIncome && !b.allTotalIncome) {
        return 1;
      }
      return a.allTotalIncome - b.allTotalIncome >= 0 ? 1 : -1;
    },
  },
  {
    key: "popTotalUSD",
    name: "推广总计",
    unit: "$",
    point: 2,
    width: 120,
    sort: true,
    sortMethod: function (a, b) {
      if (!a.popTotalUSD && !b.popTotalUSD) {
        return -1;
      } else if (!a.popTotalUSD && b.popTotalUSD) {
        return -1;
      } else if (a.popTotalUSD && !b.popTotalUSD) {
        return 1;
      }
      return a.popTotalUSD - b.popTotalUSD >= 0 ? 1 : -1;
    },
  },
  {
    key: "popuIncre",
    name: "推广新增",
    width: 120,
    point: 0,
    sort: true,
    sortMethod: function (a, b) {
      if (!a.popuIncre && !b.popuIncre) {
        return -1;
      } else if (!a.popuIncre && b.popuIncre) {
        return -1;
      } else if (a.popuIncre && !b.popuIncre) {
        return 1;
      }
      return a.popuIncre - b.popuIncre >= 0 ? 1 : -1;
    },
  },
  {
    key: "orgIncre",
    name: "自然新增",
    point: 0,
    width: 120,
    sort: true,
    sortMethod: function (a, b) {
      if (!a.orgIncre && !b.orgIncre) {
        return -1;
      } else if (!a.orgIncre && b.orgIncre) {
        return -1;
      } else if (a.orgIncre && !b.orgIncre) {
        return 1;
      }
      return a.orgIncre - b.orgIncre >= 0 ? 1 : -1;
    },
  },
  {
    key: "orgPercent",
    name: "自然量占比",
    point: 2,
    width: 140,
    sort: true,
    percent: "%",
    sortMethod: function (a, b) {
      if (!a.orgPercent && !b.orgPercent) {
        return -1;
      } else if (!a.orgPercent && b.orgPercent) {
        return -1;
      } else if (a.orgPercent && !b.orgPercent) {
        return 1;
      }
      return a.orgPercent - b.orgPercent >= 0 ? 1 : -1;
    },
    tip: "自然新增/总新增",
  },
  {
    key: "activeUser",
    name: "活跃用户",
    point: 0,
    width: 120,
    sort: true,
    sortMethod: function (a, b) {
      if (!a.activeUser && !b.activeUser) {
        return -1;
      } else if (!a.activeUser && b.activeUser) {
        return -1;
      } else if (a.activeUser && !b.activeUser) {
        return 1;
      }
      return a.activeUser - b.activeUser >= 0 ? 1 : -1;
    },
  },
  {
    key: "activePecent",
    name: "活跃新增比",
    point: 0,
    width: 140,
    sort: true,
    sortMethod: function (a, b) {
      if (!a.activePecent && !b.activePecent) {
        return -1;
      } else if (!a.activePecent && b.activePecent) {
        return -1;
      } else if (a.activePecent && !b.activePecent) {
        return 1;
      }
      return a.activePecent - b.activePecent >= 0 ? 1 : -1;
    },
  },
  {
    key: "cresCost",
    name: "新增单价",
    unit: "$",
    point: 2,
    width: 120,
    sort: true,
    sortMethod: function (a, b) {
      if (!a.cresCost && !b.cresCost) {
        return -1;
      } else if (!a.cresCost && b.cresCost) {
        return -1;
      } else if (a.cresCost && !b.cresCost) {
        return 1;
      }
      return a.cresCost - b.cresCost >= 0 ? 1 : -1;
    },
    tip: "支出总计/总新增",
  },
  {
    key: "popCost",
    name: "推广单价",
    unit: "$",
    point: 0,
    width: 120,
    sort: true,
    sortMethod: function (a, b) {
      if (!a.popCost && !b.popCost) {
        return -1;
      } else if (!a.popCost && b.popCost) {
        return -1;
      } else if (a.popCost && !b.popCost) {
        return 1;
      }
      return a.popCost - b.popCost >= 0 ? 1 : -1;
    },
    tip: "支出总计/推广新增",
  },
  {
    key: "arpu",
    name: "变现活跃ARPU",
    unit: "$",
    point: 3,
    width: 170,
    sort: true,
    sortMethod: function (a, b) {
      if (!a.arpu && !b.arpu) {
        return -1;
      } else if (!a.arpu && b.arpu) {
        return -1;
      } else if (a.arpu && !b.arpu) {
        return 1;
      }
      return a.arpu - b.arpu >= 0 ? 1 : -1;
    },
    tip: "变现收入/活跃用户",
  },

  {
    key: "increRoi",
    name: "新增ROI",
    point: 2,
    width: 120,
    percent: "%",
    sort: true,
    sortMethod: function (a, b) {
      if (!a.increRoi && !b.increRoi) {
        return -1;
      } else if (!a.increRoi && b.increRoi) {
        return -1;
      } else if (a.increRoi && !b.increRoi) {
        return 1;
      }
      return a.increRoi - b.increRoi >= 0 ? 1 : -1;
    },
    tip: "预估倍数/新增单价",
  },
  {
    key: "toDayROI",
    name: "当日ROI",
    point: 2,
    width: 120,
    percent: "%",
    sort: true,
    sortMethod: function (a, b) {
      if (!a.toDayROI && !b.toDayROI) {
        return -1;
      } else if (!a.toDayROI && b.toDayROI) {
        return -1;
      } else if (a.toDayROI && !b.toDayROI) {
        return 1;
      }
      return a.toDayROI - b.toDayROI >= 0 ? 1 : -1;
    },
    tip: "推广总计/收入总计",
  },
  {
    key: "roiTotal",
    name: "总ROI",
    point: 2,
    width: 120,
    percent: "%",
    sort: true,
    sortMethod: function (a, b) {
      if (!a.roiTotal && !b.roiTotal) {
        return -1;
      } else if (!a.roiTotal && b.roiTotal) {
        return -1;
      } else if (a.roiTotal && !b.roiTotal) {
        return 1;
      }
      return a.roiTotal - b.roiTotal >= 0 ? 1 : -1;
    },
    tip: "（累计 ）收入/支出 ，以一个固定值形式呈现",
  },
  {
    key: "retenRate1",
    name: "1留",
    sort: true,
    width: 120,
    point: 2,
    percent: "%",
    sortMethod: function (a, b) {
      if (!a.retenRate1 && !b.retenRate1) {
        return -1;
      } else if (!a.retenRate1 && b.retenRate1) {
        return -1;
      } else if (a.retenRate1 && !b.retenRate1) {
        return 1;
      }
      return a.retenRate1 - b.retenRate1 >= 0 ? 1 : -1;
    },
  },
  {
    key: "retenRate3",
    name: "3留",
    point: 2,
    width: 120,
    sort: true,
    percent: "%",
    sortMethod: function (a, b) {
      if (!a.retenRate3 && !b.retenRate3) {
        return -1;
      } else if (!a.retenRate3 && b.retenRate3) {
        return -1;
      } else if (a.retenRate3 && !b.retenRate3) {
        return 1;
      }
      return a.retenRate3 - b.retenRate3 >= 0 ? 1 : -1;
    },
  },
  {
    key: "retenRate7",
    name: "7留",
    sort: true,
    width: 120,
    percent: "%",
    sortMethod: function (a, b) {
      if (!a.retenRate7 && !b.retenRate7) {
        return -1;
      } else if (!a.retenRate7 && b.retenRate7) {
        return -1;
      } else if (a.retenRate7 && !b.retenRate7) {
        return 1;
      }
      return a.retenRate7 - b.retenRate7 >= 0 ? 1 : -1;
    },
  },
  {
    key: "retenRate14",
    name: "14留",
    width: 120,
    percent: "%",
    sort: true,
    sortMethod: function (a, b) {
      if (!a.retenRate14 && !b.retenRate14) {
        return -1;
      } else if (!a.retenRate14 && b.retenRate14) {
        return -1;
      } else if (a.retenRate14 && !b.retenRate14) {
        return 1;
      }
      return a.retenRate14 - b.retenRate14 >= 0 ? 1 : -1;
    },
  },
  {
    key: "retenRate30",
    name: "30留",
    percent: "%",
    width: 120,
    sort: true,
    sortMethod: function (a, b) {
      if (!a.retenRate30 && !b.retenRate30) {
        return -1;
      } else if (!a.retenRate30 && b.retenRate30) {
        return -1;
      } else if (a.retenRate30 && !b.retenRate30) {
        return 1;
      }
      return a.retenRate30 - b.retenRate30 >= 0 ? 1 : -1;
    },
  },
  {
    key: "payPerAdsRate",
    name: "内购收入占比",
    point: 2,
    width: 140,
    sort: true,
    percent: "%",
    sortMethod: function (a, b) {
      if (!a.payPerAdsRate && !b.payPerAdsRate) {
        return -1;
      } else if (!a.payPerAdsRate && b.payPerAdsRate) {
        return -1;
      } else if (a.payPerAdsRate && !b.payPerAdsRate) {
        return 1;
      }
      return a.payPerAdsRate - b.payPerAdsRate >= 0 ? 1 : -1;
    },
  },
];

export const role_user_column = [
  { key: "id", name: "id" },
  { key: "username", name: "账号" },
  { key: "name", name: "用户名" },
  { key: "roles", name: "角色" },
];
// export const default_sort_allreport = { prop: 'collec.totalIncre', order: 'descending' }
// { prop: 'collec.popuIncre', order: 'descending' },
// { prop: 'collec.orgIncre', order: 'descending' },
// { prop: 'collec.orgPercent', order: 'descending' },
// { prop: 'collec.activeUser', order: 'descending' },
// { prop: 'collec.activePecent', order: 'descending' },
// { prop: 'collec.cresCost', order: 'descending' },
// { prop: 'collec.popCost', order: 'descending' },
// { prop: 'collec.arpu', order: 'descending' },
// { prop: 'collec.incomeTotalUSD', order: 'descending' },
// { prop: 'collec.popTotalUSD', order: 'descending' },
// { prop: 'collec.roiTotal', order: 'descending' },
// { prop: 'collec.reten1', order: 'descending' },
// { prop: 'collec.reten3', order: 'descending' },
// { prop: 'collec.reten7', order: 'descending' },
// { prop: 'collec.reten14', order: 'descending' },
// { prop: 'collec.reten30', order: 'descending' }
function translateHeader(item) {
  let obj = {
    date: "日期",
    geo: "国家或地区",
    rmbTotal: "人民币总计",
    popTotalUS: "推广总计",
    usTotal: "美金合计",
    incomeTotalUSD: "变现收入",
  };
  return obj[item];
}
function translateHeaderWidth(item) {
  let obj = {
    rmbTotal: "150",
    popTotalUS: "150",
    incomeTotalUSD: "150",
    usTotal: "150",
  };
  return obj[item];
}

export const extensionHeader_column = (obj, header, def, sign) => {
  let sortObj = obj.sort();
  if (header === {} || !header) return [];
  let arr = [];
  let delKey = def == "1" ? "geo" : "date";
  delete header[delKey];
  for (let item in header) {
    let o = item.split("_")[0];
    if (sortObj.filter((data) => data.toLowerCase().includes(o.toLowerCase())).length == 0) {
      let temp = {
        key: item,
        name: translateHeader(item) ? translateHeader(item) : item,
        sort: true,
        width: translateHeaderWidth(item) ? translateHeaderWidth(item) : 120,
        sortMethod: (a, b) => sortColumn(a, b, item),
      };

      if (item.indexOf("rmb") >= 0) {
        temp["unit"] = "￥";
      } else if (item.indexOf("US") >= 0 || item.indexOf("us") >= 0) {
        temp["unit"] = "$";
      }
      arr.push(temp);
    }
  }
  let index = 4;
  sortObj.forEach((v, i) => {
    const signIndex = sign.findIndex((s) => s.media === v)
    arr.push({
      key: v,
      name: v,
      // sort: true,
      children: [
        {
          key: `${v}_spent`,
          name: "支出",
          unit: sign[signIndex].currencyFlag,
          sort: true,
          width: 120,
          sortMethod: (a, b) => sortColumn(a, b, `${v}_spent`),
          index: index + i * 4,
        },
        {
          key: `${v}_trans`,
          name: "转化",
          sort: true,
          sortMethod: (a, b) => sortColumn(a, b, `${v}_trans`),
          index: index + 1 + i * 4,
        },
        {
          key: `${v}_cost`,
          name: "成本",
          unit: sign[signIndex].currencyFlag,
          sort: true,
          width: 120,
          sortMethod: (a, b) => sortColumn(a, b, `${v}_cost`),
          index: index + 2 + i * 4,
        },
        {
          key: `${v}_素材`,
          name: "素材",
          sort: true,
          width: 120,
          index: index + 3 + i * 4,
          sortMethod: function (a, b) {
            return a[`${v}_素材`] - b[`${v}_素材`];
          },
        },
      ],
    });
  });
  // [arr[1], arr[2]] = [arr[2], arr[1]];
  return arr;
};
function translateIncome(item) {
  let obj = {
    date: "日期",
    geo: "国家或地区",
    popTotalUS: "推广总计",
    usTotal: "美金收入",
    incomeTotalUSD: "变现收入",
    rmbTotal: "RMB(收入)",
    usd: "美金收入",
  };
  return obj[item];
}
export const income_table_column = (param, key, unitMap) => {
  let arr = [],
    temp = [],
    temp1 = [],
    tempObj = {},
    arrayColumn = [];
  let delKey = key == "1" || key == "" ? "geo" : "date";
  delete param[delKey];
  for (let item in unitMap) {
    // item = `${item}_cost`
    tempObj[`${item}`] = unitMap[item];
  }
  let obj = { ...param, ...tempObj };
  for (let item in obj) {
    let obj = {};
    // if ((item == "date")) {
    //   obj['fixed'] = true
    // }
    obj["key"] = translateIncome(item) ? item : `${item}_cost`;
    obj["name"] = translateIncome(item) ? translateIncome(item) : item;
    obj["sort"] = true;
    obj["width"] == 200;
    obj["sortMethod"] = (a, b) => sortColumn(a, b, translateIncome(item) ? item : `${item}_cost`);
    // obj['sortMethod'] = function (a, b) {
    //   console.log(a, b, item)
    //   if (!a[item] && !b[item]) {
    //     return -1
    //   } else if (!a[item] && b[item]) {
    //     return -1
    //   } else if (a[item] && !b[item]) {
    //     return 1
    //   }
    //   return a[item] - b[item] >= 0 ? 1 : -1
    // }
    for (let v in unitMap) {
      if (item == v) {
        obj["unit"] = unitMap[item] == "true" ? "￥" : "$";
      }
    }
    if (item.indexOf("rmb") >= 0) {
      obj["unit"] = "￥";
    } else if (item.indexOf("US") >= 0 || item.indexOf("us") >= 0) {
      obj["unit"] = "$";
    }
    arr.push(obj);
  }

  arr.map((v) => {
    if (translateIncome(v.key)) {
      temp.push(v);
    } else {
      v.width = 120;
      temp1.push(v);
    }
  });

  arrayColumn = temp.concat(temp1);

  return arrayColumn;
};
export const osTypeFu = (num) => {
  switch (num) {
    case 1:
      return "android";
    case 2:
      return "google";
    case 3:
      return "ios";
    default:
      return "-";
  }
};
export const osTypeFuNum = (str) => {
  switch (str) {
    case "android":
      return 1;
    case "google":
      return 2;
    case "ios":
      return 3;
    default:
      return str;
  }
};
export const statueFunString = (value) => {
  return value === 1 ? "是" : "否";
};

export const statueFunNum = (value) => {
  return value ? 1 : 0;
};

export const resetMenu = (menu) => {
  let route1 = [];
  let parentRoute = [];

  menu.map((value) => {
    if (value.parentId === 0) {
      route1.push(value);
    } else {
      parentRoute.push(value);
    }
  });
  route1.map((value) => {
    parentRoute.map((item) => {
      if (item.parentId == value.menuId) {
        if (value.children) {
          value.children.push(item);
        } else {
          value.children = [];
          value.children.push(item);
        }
      }
    });
  });

  return { route1 };
};

export const findArray = (arr1, arr2) => {
  let arr = [],
    temp = [];
  arr1.forEach((v) => {
    arr2.includes(v.key.toString()) ? null : arr.push(v);
  });
  arr.map((v) => {
    temp.push(v.key.toString());
  });
  return temp.join();
};

export const asideIcon = {
  产品管理: "el-icon-more",
  用户报表: "el-icon-user",
  推广报表: "el-icon-s-help",
  收入报表: "el-icon-pie-chart",
  汇总报表: "el-icon-s-check",
  总览报表: "el-icon-s-data",
  用户管理: "el-icon-s-custom",
  角色管理: "el-icon-user-solid",
  应用权限分配: "el-icon-s-open",
  参数配置: "el-icon-setting",
  登录日志: "el-icon-video-camera",
  华为报表: "el-icon-s-operation",
};

export const huaweiRportColumn = [
  { key: "showCount", name: "展示量", value: "-" },
  { key: "clickCount", name: "点击量", value: "-" },
  { key: "downloadCount", name: "下载完成量", width: 100, value: "-" },
  { key: "installCount", name: "安装完成量", width: 100, value: "-" },
  { key: "activeCount", name: "激活量", value: "-" },
  {
    key: "clickRate",
    name: "点击率 ",
    percent: "%",
    value: "-",
    iconshow: true,
    message: "点击量/展示量",
  },
  {
    key: "activeRate",
    name: "激活率",
    percent: "%",
    value: "-",
    iconshow: true,
    message: "激活数/点击数",
  },
  {
    key: "downloadRate",
    name: "下载完成率",
    percent: "%",
    width: 100,
    value: "-",
    iconshow: true,
    message: "下载完成量/安装完成量",
  },
  {
    key: "installRate",
    name: "安装完成率",
    percent: "%",
    width: 100,
    value: "-",
    iconshow: true,
    message: "安装完成量/下载完成量",
  },
  { key: "cost", name: "消耗", value: "-" },
  {
    key: "downloadCost",
    name: "下载成本",
    value: "-",
    width: 100,
    iconshow: true,
    message: "消耗/下载完成量",
  },
  {
    key: "activeCost",
    name: "激活成本",
    value: "-",
    width: 100,
    iconshow: true,
    message: "消耗/激活数",
  },
  { key: "dau", name: "活跃用户", value: "-" },
  { key: "income", name: "收入总计(RMB)", width: 120, value: "-" },
  {
    key: "incRoi",
    name: "新增roi",
    value: "-",
    iconshow: true,
    message: "当日新增收入/当日消耗",
  },
  {
    key: "arpu",
    name: "活跃APRU",
    value: "-",
    width: 100,
    iconshow: true,
    message: "收入/活跃用户数",
  },
  {
    key: "estimateValue",
    name: "估算变现价值",
    width: 120,
    value: "-",
    iconshow: true,
    message: "活跃arpu*预估倍数",
  },
  {
    key: "estimateTimes",
    name: "预估倍数",
    value: "-",
    width: 100,
    iconshow: true,
    message: "依据当前留存的幂公式预估30天留存/0.025*5",
  },
  { key: "retention1", name: "1留", value: "-" },
  { key: "retention3", name: "3留", value: "-" },
  { key: "retention7", name: "7留", value: "-" },
  { key: "retention14", name: "14留", value: "-" },
  { key: "retention30", name: "30留", value: "-" },
];
export const huaweiData = [
  {
    installDay: 20120101,
    showCount: 100,
    clickCount: 300,
    downloadCount: 122,
    installCount: 3000,
    activeCount: 1212,
    clickRate: 12.34,
    activeRate: 32.22,
    downloadRate: 3.22,
    installRate: 3.15,
    cost: 32,
    downloadCost: 897,
    activeCost: 12,
    dau: 12,
    income: 45,
    incRoi: 53,
    arpu: 77,
    estimateValue: 23,
    estimateTimes: 12,
    retention1: 33,
    retention3: 3,
    retention7: 22,
    retention15: 11,
    retention30: 3,
  },
  {
    installDay: 20120101,
    showCount: 100,
    clickCount: 300,
    downloadCount: 122,
    installCount: 3000,
    activeCount: 1212,
    clickRate: 12.34,
    activeRate: 32.22,
    downloadRate: 3.22,
    installRate: 3.15,
    cost: 32,
    downloadCost: 897,
    activeCost: 12,
    dau: 12,
    income: 45,
    incRoi: 53,
    arpu: 77,
    estimateValue: 23,
    estimateTimes: 12,
    retention1: 33,
    retention3: 3,
    retention7: 22,
    retention15: 11,
    retention30: 3,
  },
  {
    installDay: 20120101,
    showCount: 100,
    clickCount: 300,
    downloadCount: 122,
    installCount: 3000,
    activeCount: 1212,
    clickRate: 12.34,
    activeRate: 32.22,
    downloadRate: 3.22,
    installRate: 3.15,
    cost: 32,
    downloadCost: 897,
    activeCost: 12,
    dau: 12,
    income: 45,
    incRoi: 53,
    arpu: 77,
    estimateValue: 23,
    estimateTimes: 12,
    retention1: 33,
    retention3: 3,
    retention7: 22,
    retention15: 11,
    retention30: 3,
  },
];
export const sumData = [
  "总计",
  100,
  300,
  122,
  3000,
  1212,
  12.34,
  32.22,
  3.22,
  3.15,
  32,
  897,
  12,
  99,
  12,
  45,
  53,
  77,
  23,
  12,
  33,
  22,
  11,
  3,
  2,
  1,
  1,
];
